import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserRoutingModule } from './user-routing.module';
import { UserComponent } from 'src/app/pages/user/user.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { PreloadSpinnerModule } from 'src/app/shared/preload-spinner/preload-spinner.module';
import { CustomContentDropdownComponent } from 'src/app/shared/custom-content-dropdown/custom-content-dropdown.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ButtonModule } from 'src/app/shared/button/button.module';


@NgModule({
  declarations: [
    UserComponent,
    CustomContentDropdownComponent,
  ],
  imports: [
    CommonModule,
    UserRoutingModule,
    PreloadSpinnerModule,
    TranslateModule,
    AngularSvgIconModule,
    ButtonModule,
  ],
  exports: [
    UserComponent,
  ],
  providers: [
    TranslatePipe,
  ],
})
export class UserModule { }
